if (!customElements.get('sticky-atc')) {
  class ProductStickyATC extends DetailsModal {
    constructor() {
      super();
    }

    connectedCallback() {
      this.coreATC = document.querySelector('.product-form__buttons--main');

      this.createTimeline();
      this.createObserver();
    }

    disconnectedCallback() {
      this.destroyObserver();
    }

    createTimeline() {
      this.timeline = gsap.timeline({ paused: true });
      this.timeline.fromTo(
        this,
        { autoAlpha: 1 },
        {
          autoAlpha: 0,
          duration: 0.5,
          ease: 'power2.inOut',
        }
      );
    }

    createObserver() {
      this.observer = new IntersectionObserver(
        (entries, observer) => {
          if (entries[0].isIntersecting) {
            this.hide();
          } else {
            this.show();
          }
        },
        {
          rootMargin: `${this.coreATC.offsetHeight}px 0px 0px 0px`,
          threshold: 1,
        }
      );

      this.observer.observe(this.coreATC);
    }

    destroyObserver() {
      this.observer.disconnect();
      this.timeline.revert();
    }

    hide() {
      this.timeline.play();
    }

    show() {
      this.timeline.reverse();
    }
  }

  customElements.define('sticky-atc', ProductStickyATC);
}